/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [{
  path: '*',
  redirect: '/'
}, {
  path: '/',
  component: () => import('@/views/index/index'),
  meta: {
    title: '首页',
    keepAlive: false,
    needLogin: false,
    index: 0
  }
}, {
  path: '/companyInfo',
  component: () => import('@/views/companyInfo/index'),
  meta: {
    title: '公司介绍',
    needLogin: false,
    index: 1
  }
}, {
  path: '/service',
  component: () => import('@/views/service/index'),
  meta: {
    title: '核心优势与服务',
    needLogin: false,
    index: 1
  }
}, {
  path: '/personalHealth',
  component: () => import('@/views/personalHealth/index'),
  meta: {
    title: '个人健康',
    needLogin: false,
    index: 2
  }
}, {
  path: '/familyHealth',
  component: () => import('@/views/familyHealth/index'),
  meta: {
    title: '家庭健康',
    needLogin: false,
    index: 2
  }
}, {
  path: '/cancerInfo',
  component: () => import('@/views/cancerInfo/index'),
  meta: {
    title: '癌症详情',
    needLogin: false,
    index: 7
  }
}, {
  path: '/healthyTips',
  component: () => import('@/views/healthyTips/index'),
  meta: {
    title: '健康资讯',
    needLogin: false,
    index: 2
  }
}, {
  path: '/healthyTipsDetails',
  component: () => import('@/views/healthyTips/details'),
  meta: {
    title: '健康资讯',
    needLogin: false,
    index: 3
  }
}, {
  path: '/vipService',
  component: () => import('@/views/vipService/index'),
  meta: {
    title: '会员服务',
    needLogin: false,
    index: 6
  }
}, {
  path: '/healthyService',
  component: () => import('@/views/healthyService/index'),
  meta: {
    title: '企业健康',
    needLogin: false,
    index: 1
  }
}, {
  path: '/orderDetails',
  name: 'orderDetails',
  component: () => import('@/views/orderDetails/index'),
  meta: {
    title: '订单详情',
    needLogin: false,
    index: 3
  }
}, {
  path: '/personalHealthNo',
  component: () => import('@/views/personalHealthNo/index'),
  meta: {
    title: '订单详情',
    needLogin: false,
    index: 3.5
  }
}, {
  path: '/addOrder',
  component: () => import('@/views/addOrder/index'),
  meta: {
    title: '加项',
    needLogin: false,
    keepAlive: true,
    isBack: false,
    index: 2.5
  }
}, {
  path: '/renew',
  component: () => import('@/views/renew/index'),
  meta: {
    title: '续费',
    needLogin: false,
    index: 7
  }
}, {
  path: '/serviceInfo',
  component: () => import('@/views/serviceInfo/index'),
  meta: {
    title: '服务详情',
    needLogin: false,
    index: 7
  }
}, {
  path: '/contactUs',
  component: () => import('@/views/contactUs/index'),
  meta: {
    title: '联系我们',
    needLogin: false,
    index: 10
  }
}, {
  path: '/login',
  component: () => import('@/views/login/index'),
  meta: {
    title: '首页',
    index: 0
  }
}, {
  path: '/orderConfirm',
  component: () => import('@/views/orderConfirm/index'),
  meta: {
    title: '支付订单',
    index: 5
  }
}, {
  path: '/questionnaire',
  component: () => import('@/views/questionnaire/index'),
  meta: {
    title: '调查问卷',
    index: 10
  }
}, {
  path: '/productList',
  component: () => import('@/views/productList/index'),
  meta: {
    title: '产品列表',
    index: 2
  }
}, {
  path: '/productList/item',
  component: () => import('@/views/productList/children/index'),
  meta: {
    title: '',
    index: 3
  }
}, {
  path: '/uploadFile',
  component: () => import('@/views/uploadFile/index'),
  meta: {
    title: '文件上传',
    index: 2
  }
}];